import React from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router';
import Footer from './footer/Footer';
import Header from './header/Header';

const MAIN_CONTENT_ID = 'main-content';

// Focus is moved programmatically: a plain "#hash" navigation would go through the router (ScrollToTop, LanguageMonitor).
const skipToContent = event => {
	event.preventDefault();
	const target = document.getElementById(MAIN_CONTENT_ID);
	target?.focus();
	target?.scrollIntoView();
};

const LayoutClassic = () => {
	const { t } = useTranslation();

	return (
		<>
			<a className="skip-link" href={`#${MAIN_CONTENT_ID}`} onClick={skipToContent}>
				{t('a11y_skip_to_content')}
			</a>
			<Header />
			{/* The single main landmark of every page (pages must not render their own <main>). */}
			<main id={MAIN_CONTENT_ID} tabIndex={-1}>
				<Outlet />
			</main>
			<Footer />
		</>
	);
};

export default LayoutClassic;
